/* eslint-disable sort-keys-fix/sort-keys-fix */
const QuestionComponents = {
    QUESTION: "question",
    QUESTION_TEXT: "questionText",
    CHOICE: "choice",
    CHOICE_IMAGE: "choiceImage",
    FEEDBACK: "feedback",
};

export default QuestionComponents;
